import { useContext } from "react";
import MultiStepFormContext from "./MultiStepFormContext";

const useDatasource = () => {
  const { details } = useContext(MultiStepFormContext);
  const dataSource = [
    {
      key: "1",
      document_title: "Passport size photo",
      document_url: "",
      document_id: "passportPhoto",
      required: true,
    },
    {
      key: "2",
      document_title:
        "College or institute enrolment proof (admission letter/bonafide certificate)",
      document_url: "",
      document_id: "enrolmentProof",
      required: true,
    },
    {
      key: "3",
      document_title: "10th Board Mark sheet",
      document_url: "",
      document_id: "SSCMarksheet",
      required: true,
    },
    {
      key: "4",
      document_title: "12th Board/Diploma Mark sheet",
      document_url: "",
      document_id: "HSCMarksheet",
      required: true,
    },
    {
      key: "5",
      document_title:
        "Last school/college test/semester end/annual exam Mark sheet (if applicable)",
      document_url: "",
      document_id: "examMarksheet",
      required: false,
    },
    {
      key: "6",
      document_title:
        "Proof of address (Aadhar card/Ration card/Rent Agreement, etc.)",
      document_url: "",
      document_id: "addressProof",
      required: true,
    },
    {
      key: "7",
      document_title:
        "Proof of identity (Aadhaar Card/Leaving Certificate/School ID/College ID)",
      document_url: "",
      document_id: "identityProof",
      required: true,
    },
    {
      key: "8",
      document_title:
        "PDF of applicant’s house pictures (3-4 from outside and inside)",
      document_url: "",
      document_id: "housePictures",
      required: true,
    },
    {
      key: "9",
      document_title: "Annual Fee structure",
      document_url: "",
      document_id: "annualFeeStructure",
      required: true,
    },
    {
      key: "10",
      document_title:
        "Fee Payment receipts for educational-related expenses, such as tuition fees, hostel fees, books, mess fees, etc., (if applicable)",
      document_url: "",
      document_id: "expenseReceipts",
      required: false,
    },
    {
      key: "11",
      document_title:
        "Proof of family income such as Form 16/ITR/salary slips/income certificate by a concerned government authority/bank passbook, etc.",
      document_url: "",
      document_id: "familyIncomeProof",
      required: true,
    },
    {
      key: "12",
      document_title: "Document proof for physical disability (if applicable)",
      document_url: "",
      document_id: "disabilityDocument",
      required: false,
    },
    {
      key: "13",
      document_title: "Latest electricity bill",
      document_url: "",
      document_id: "electricityBill",
      required: true,
    },
    {
      key: "14",
      document_title: "Cast Certificate (SC,ST,OBC,Other)",
      document_url: "",
      document_id: "castCertificate",
      required: details.category.value !== "General" ? true : false,
    },
    {
      key: "15",
      document_title: "Other mark sheets",
      document_url: "",
      document_id: "otherMarksheet",
      required: false,
    },
  ];
  return { dataSource };
};

export default useDatasource;
